<div class="flex h-screen w-screen items-center justify-center">
  <div class="text-2xl" *ngIf="loading">
    <span class="loader"></span>
    Caricamento...
  </div>
  <div class="w-full p-4 md:w-1/4" *ngIf="!loading">
    <div class="alert alert-danger">
      {{ errorMessage || 'Si è verificato un errore.' }}
    </div>
  </div>
</div>
